import HourStateLabel from 'components/HourStateLabel';
import React from 'react';
import type { HourState } from 'redux/modules/hourStates.schema';
import { defaultStateId } from '../../../redux/modules/hourStates.constants';
import styles from './column.module.scss';
import { COLUMN_SIZE_MEDIUM } from './constants';
import HeaderWithMenu from './HeaderWithMenu';
import type { DatatableCellRenderer, DatatableColumnGetter } from './types';

export const getStateColumn: DatatableColumnGetter<HourState, { label: string }> = (
  id: string,
  { label } = { label: 'State' }
) => ({
  id,
  header: props => (
    <HeaderWithMenu
      {...props}
      label={label}
      filterTriggerSelector='[data-testid="button_hour_states_filter_dropdown"]'
    />
  ),
  size: COLUMN_SIZE_MEDIUM,
  minSize: COLUMN_SIZE_MEDIUM,
  enableResizing: true,
  enableSorting: false,
  meta: {
    numeric: false,
    label: 'State',
    mandatory: true,
  },
  cell: StateCell,
});

export const StateCell: DatatableCellRenderer<HourState> = ({ getValue }) => {
  const hourState = getValue();
  if (!hourState || hourState.id === defaultStateId) {
    return null;
  }
  return <HourStateLabel state={hourState} size="small" inline className={styles.hourState} />;
};
